import { combineReducers, Reducer } from 'redux';

import { alertReducer } from './AlertReducer';
import { authReducer } from './AuthReducer';
import { apiDocReducer } from './ApiDocReducer';
import { apiEndpointsReducer } from './ApiEndpointsReducer';
import { partnersListReducer } from './PartnersListReducer';
import { contextPropertyReducer } from './ContextPropertyReducer';
import { partnerMemberReducer } from './PartnerMemberReducer';
import { partnerPermissionsReducer } from './PartnerPermissionsReducer';
import { userManagerReducer } from './UserManagerReducer';

import { 
  IAlertState, 
  IAuthState, 
  IApiDocState,
  IPartnersListState, 
  IContextPropertyState, 
  IPartnerMemberState,
  IPartnerPermissionsState, 
  IApiEndpointsState,
  IUserManagerState
} from './../types';

export interface IRootState {
  alertState: IAlertState;
  authState: IAuthState;
  apiDocState: IApiDocState;
  apiEndpointsState: IApiEndpointsState;
  partnersListState: IPartnersListState;
  contextPropertyState: IContextPropertyState;
  partnerMemberState: IPartnerMemberState;
  partnerPermissionsState: IPartnerPermissionsState;
  userManagerState: IUserManagerState;
}

const rootReducer: Reducer<IRootState> = combineReducers<IRootState>({
  alertState: alertReducer,
  authState: authReducer,
  apiDocState: apiDocReducer,
  apiEndpointsState: apiEndpointsReducer,
  partnersListState: partnersListReducer,
  contextPropertyState: contextPropertyReducer,
  partnerMemberState: partnerMemberReducer,
  partnerPermissionsState: partnerPermissionsReducer,
  userManagerState: userManagerReducer,
});

export default rootReducer; 


// WEBPACK FOOTER //
// ./src/reducers/index.ts